export default "__VITE_ASSET__C9Uj$c4S__"